/**
 * Site Header
 */


/*
 *  Nav Drawer 
 */
(jQuery)(function($){

    $(document).ready(function(){

        $('.nav-toggle').on('click', function(){
            $('.site-header').toggleClass('drawer-open');
            $('.nav-drawer').toggleClass('active');
        });


    });

});


/*
*   Header + Peekaboo
*/
let prevScrollPos = window.scrollY;
const header = document.getElementById('masthead');
var peekabooPrepared = false;

window.onscroll = function() {
    let currentScrollPos = window.scrollY;

    if (prevScrollPos > currentScrollPos) {
        // User is scrolling up, add the "active" class to show the header
        header.classList.add('peekaboo-active');
        header.classList.remove('peekaboo-deactive');


        // User reaches the top of the page, revert to initial header
        if(currentScrollPos <= 2) {
            header.classList.remove('peekaboo-active');
            header.classList.remove('peekaboo-deactive');

            peekabooPrepared = false;
        }

    } else {
        // Inital header is out of view, prepare the peekaboo header
        if(currentScrollPos >= 94 && !peekabooPrepared) {
            header.classList.add('peekaboo-prepare');

            setTimeout(function(){
                header.classList.remove('peekaboo-prepare');
                header.classList.add('peekaboo-deactive');
            }, 250);

            peekabooPrepared = true;
        }

        // User is scrolling down, hide peekaboo header
        if(currentScrollPos >= 94){
            header.classList.add('peekaboo-deactive');
            header.classList.remove('peekaboo-active');
            header.classList.remove('peekaboo-top');
        }
    }

    prevScrollPos = currentScrollPos;
}